import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages } from 'react-intl'

import {
  Wrapper,
  Image,
  TextImageWrapper,
  Title
} from './Blurb.styles'
import { GradientWrapper } from '../../../../DashboardSettings.styles'

const messages = defineMessages({
  encourageToSubscribe: {
    id: 'dashboard.referrals.encourageToSubscribe',
    defaultMessage: 'Night Zookeeper has a huge impact on writing attainment when you build a large audience for your students. Encourage other teachers to subscribe and create a fantastic writing community in your school today!'
  }
})

const Blurb = (props) => {
  return (
    <GradientWrapper direction={props.direction}>
      <Wrapper>
        <TextImageWrapper>
          <Image />
          <Title>
            <FormattedMessage {...messages.encourageToSubscribe} />
          </Title>
        </TextImageWrapper>
      </Wrapper>
    </GradientWrapper>
  )
}

export default Blurb
